import React from "react";

/**
 * Quiet header for the single-page mortgage lander.
 * No nav - one page, one action. Just a plain wordmark and a direct line
 * to Dorian for anyone who'd rather skip the form.
 */
// Same source as the qualifier's handoff CTAs (REACT_APP_DORIAN_PHONE, E.164).
const DORIAN_PHONE = process.env.REACT_APP_DORIAN_PHONE || "+15875550100";
const DORIAN_PHONE_DISPLAY = DORIAN_PHONE.replace(/^\+1(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3");

export default function Header() {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="z-container site-header-inner">
        <a href="#top" className="site-wordmark" data-testid="site-wordmark">
          Dorian Reeves
          <small>Mortgage Associate · MMG Mortgages</small>
        </a>
        <a
          href={`tel:${DORIAN_PHONE}`}
          className="site-header-cta"
          data-testid="header-call-link"
        >
          {DORIAN_PHONE_DISPLAY}
        </a>
      </div>
    </header>
  );
}
